/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class RestoreRdsInstanceClasses {
  /**
  * The available instance classes for the engine in the region
  */
  'instanceClasses': Array<string>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "instanceClasses",
      "baseName": "instanceClasses",
      "type": "Array<string>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreRdsInstanceClasses.attributeTypeMap;
  }

  public constructor() {
  }
}

